import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useSelector, useDispatch } from 'react-redux';

import { accordionSlice, apiSlice, itemSlice } from 'configurator-ui-shared';
import { upsellsSlice } from '../features/upsells/store/upsellsSlice';
import multiConfigReducer from '../features/multiConfig/store/multiConfigSlice';

export const configuratorStore = configureStore({
  reducer: {
    accordion: accordionSlice.reducer,
    item: itemSlice.reducer,
    upsells: upsellsSlice.reducer,
    multiConfig: multiConfigReducer,
    [apiSlice.reducerPath]: apiSlice.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(apiSlice.middleware)
});

export type RootState = ReturnType<typeof configuratorStore.getState>;

export type ConfiguratorDispatch = typeof configuratorStore.dispatch;

export const useConfiguratorDispatch: () => ConfiguratorDispatch = useDispatch;

export const useRootSelector: TypedUseSelectorHook<RootState> = useSelector;
